export enum HostNames {
  'www.bevnet.com' = 1,
  'localhost:3101' = 1,

  'localhost:3103' = 2,
  'www.brewbound.com' = 2,

  'localhost:3102' = 3,
  'www.nosh.com' = 3,
}
export enum Hosts {
  BEVNET = 1,
  BREWBOUND = 2,
  NOSH = 3,
  CPGJOBS = 8,
}

// CPG Jobs packs grant 5 listings per pack; the BevNET/Brewbound/NOSH packs
// grant 6 (5 purchased + 1 free). Single source of truth for the per-pack count so
// the package UI (listings column, pack description, order recap, savings promo)
// stays in sync with the backend entitlement (JobsPrepaidService). See D-24371.
export const getListingsPerPack = (siteNumber: number): number =>
  (siteNumber === Hosts.CPGJOBS ? 5 : 6);

// The +1 free-listing bonus applies to every brand except CPG Jobs.
export const hasFreeListingBonus = (siteNumber: number): boolean =>
  siteNumber !== Hosts.CPGJOBS;
